import {Component, Input,} from '@angular/core';
import {Currencies} from "../../interfaces/currencies";
import {HeaderService} from "../../services/header.service";
import {LocalStorageService} from "../../services/local-storage.service";

@Component({
  selector: 'app-modal-currencies',
  templateUrl: './modal-currencies.component.html',
  styleUrls: ['./modal-currencies.component.scss']
})
export class ModalCurrenciesComponent {
  @Input()
  exchangeRatesEUR: string;

  @Input()
  exchangeRatesUSD: string;

  @Input()
  getCurrencies: Currencies[];

  public isModalsCurrenciesShow: boolean = false;
  public isDarkBackground: boolean = false;


  constructor(
    public headerService: HeaderService,
    private localStorage: LocalStorageService
  ) {
  }

  modalCurrenciesShow() {
    this.isModalsCurrenciesShow = true;
    this.isDarkBackground = true;
  }

  getCurrency(id) {
    this.localStorage.set('currencies', id);

    this.headerService.currency.next(id);
    this.isModalsCurrenciesShow = false;
    this.isDarkBackground = false;
  }

  closeModal() {
    this.isModalsCurrenciesShow = false;
    this.isDarkBackground = false;
  }
}
